import React, {useEffect} from "react";
import {Button, Form, Input, Select, Col, Row, TreeSelect} from "antd";
import {useModel} from "../../../models"

const {Option} = Select
const rangeConfig = {
    rules: [{type: 'array', required: true, message: 'Please select time!'}],
};
const customerSel = [
    {type: "一般客户"},
    {type: "单位客户"},
    {type: "公交客户"},
    {type: "中字头客户"},


]
export default function () {
    const [{SearchParams}, {setSearchParams, loadCustomerList}] = useModel("customerBill")
    const [{customerTypeDict, engineTypeDict}, {getCustomerTypeDict, getEngineTypeDict}] = useModel("cmDict");
    useEffect(() => {
        // debugger;
        getCustomerTypeDict()
    }, []);
    const [form] = Form.useForm();
    const onFinish = () => {
        let data = form.getFieldsValue()
        data.pageSize = 15
        data.pageNum = 1
        // return console.log(data)
        setSearchParams(data)
        loadCustomerList({data})
    }
    const chongzhi = () => {
        form.resetFields()
        setSearchParams({})
        loadCustomerList({data: {}})

    }
    return (
        <Form
            form={form}
            name="material_search"
            layout="inline"
            labelCol={{span: 12}}
            onFinish={onFinish}
        >
            <Form.Item
                name="customerName"
                label="客户名称"
            >
                <Input placeholder="客户名称" style={{width: "200px"}}/>
            </Form.Item>
            <Form.Item
                name="customerType"
                label="客户类型"
            >
                <TreeSelect
                    showSearch
                    allowClear
                    dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                    placeholder="客户类型"
                    treeDefaultExpandAll
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    onChange={() => {
                    }}
                    treeData={customerTypeDict}
                    style={{width: "200px"}}
                />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit" className="margin-left-16">查询</Button>
                <Button onClick={chongzhi} className="margin-left-8">重置</Button>
            </Form.Item>
        </Form>
    );
}